import React, { useState } from "react";
import { CancelButton, SaveButton, DrawerComponent } from "@comps/components";
import { makeRequest, notify } from "@utils/helpers";
import { updateCaseStatusReq } from "../requests";
import CaseStatusForm from "./CaseStatusForm";

const formName = "CaseStatuss";
const UpdateCaseStatus = (props) => {
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  const onFinish = (data) => {
    let payload = {
      "object": {
        id: props.data.id,
        name: data.name,
        order: data.order,
        description: data.description,
      }
    }
    makeRequest(setLoader, updateCaseStatusReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    notify("CaseStatus Updated", res.msg);
    props.onUpdated(data.object);
  }

  const onError = (err) => {
    let errorList = [];
    errorList['name'] = err.name;
  }

  return (
    <DrawerComponent mainTitle="Update" subTitle="CaseStatus" open={ true } footer={ false } onClose={ () => props.onClosed(false) }>
      <CaseStatusForm setErrors={ setErrors } errors={ errors } initialData={ props.data } onFinish={ onFinish } formName={ formName } />
      <div className="form-actions">
        <CancelButton key="close_button" onClick={ () => props.onClosed(false) } />
        <SaveButton form={ formName } key="create_button" htmlType="submit" state={ loader } />
      </div>
    </DrawerComponent>
  );
}

export default UpdateCaseStatus
